import createReactComponent from '../createReactComponent';
export default createReactComponent('align-left', 'IconAlignLeft', [
  ['path', { d: 'M4 6l16 0', key: 'svg-0' }],
  ['path', { d: 'M4 12l10 0', key: 'svg-1' }],
  ['path', { d: 'M4 18l14 0', key: 'svg-2' }],
]);
